import { render, staticRenderFns } from "./RemoveALawyer.vue?vue&type=template&id=97babc54&scoped=true&"
import script from "./RemoveALawyer.vue?vue&type=script&lang=ts&"
export * from "./RemoveALawyer.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveALawyer.vue?vue&type=style&index=0&id=97babc54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97babc54",
  null
  
)

export default component.exports